export default __webpack_public_path__ + "static/media/3-3.e08fd21e.webp";